module.exports = __webpack_public_path__ + "img/dracula-13.91f09229.jpg";